module.exports = __webpack_public_path__ + "static/media/midas.5dc05660.svg";